import { saleTaxCreditColumns } from './taxCreditColumns';
import { saleCreditNoteColumns } from './creditNoteColumns';
import { consumerFinalProductColumns } from './consumerInvoiceColumns';
import { saleExportInvoiceColumns } from './exportInvoiceColumns';

/**
 * 🗂️ Mapa centralizado de columnas para productos en documentos de ventas.
 *
 * 🔗 Uso típico:
 * ```ts
 * import { saleColumnsMap } from '.../sales/columns';
 * const columns = saleColumnsMap.CONSUMER_INVOICE;
 * ```
 */
export const saleColumnsMap = {
  /** 📜 Columnas para Crédito Fiscal (Ventas) */
  TAX_CREDIT: saleTaxCreditColumns,

  /** 📜 Columnas para Nota de Crédito (Ventas) */
  CREDIT_NOTE: saleCreditNoteColumns,

  /** 📜 Columnas para Factura Consumidor Final (Ventas) */
  CONSUMER_INVOICE: consumerFinalProductColumns,

  EXPORT_INVOICE: saleExportInvoiceColumns,
};
